import { Backdrop, CircularProgress } from '@mui/material';

export default function Spinner(props) {
  return (
    <Backdrop open={props.open} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.tooltip + 1 }}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
}
